import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';

// TODO: temporary – validity check and late submission are only available on
// staging and localhost until they go live on prod. Remove this guard afterwards.
export function isStagingHost(hostname: string): boolean {
  return hostname.includes('staging') || hostname === 'localhost';
}

export const stagingOnlyGuard: CanActivateFn = () => {
  const document = inject(DOCUMENT);
  const router = inject(Router);

  if (isStagingHost(document.location.hostname)) {
    return true;
  }
  return router.createUrlTree(['/signup']);
};
